module.exports = __webpack_public_path__ + "img/20250911100029363.0d197558.png";